import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { BellRing, BellOff, Download, Smartphone, Monitor } from "lucide-react";
import { disablePush, enablePush, getPushSubscription, pushSupported, useInstallPrompt } from "../lib/pwa";
import { InstallGuide } from "./InstallButton";

export const PushSection = () => {
  const [sub, setSub] = useState(null);
  const [count, setCount] = useState(null);
  const [busy, setBusy] = useState(false);
  const [guide, setGuide] = useState(false);
  const { canInstall, install, standalone } = useInstallPrompt();
  const supported = pushSupported();
  const denied = supported && Notification.permission === "denied";

  const load = () => {
    getPushSubscription().then(setSub).catch(() => {});
    api.get("/push/status").then((r) => setCount(r.data.subscriptions)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (sub) { await disablePush(); toast.success("Bu cihazda bildirimler kapatıldı"); }
      else { await enablePush(); toast.success("Bildirimler açıldı — işlem açılış/kapanışları bu cihaza düşecek"); }
      load();
    } catch (e) { toast.error(e?.response ? apiError(e) : e.message); }
    setBusy(false);
  };
  const test = async () => {
    setBusy(true);
    try { const { data } = await api.post("/push/test"); toast.success(`Test bildirimi gönderildi (${data.sent} cihaz)`); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <section data-testid="push-section" className="bg-[#121724] border border-[#1E2738] rounded-lg p-5 space-y-4">
      <div>
        <h3 className="text-sm font-bold flex items-center gap-2"><BellRing className="h-4 w-4 text-[#3B82F6]" /> Uygulama & Anlık Bildirimler</h3>
        <p className="text-xs text-[#64748B] mt-1">Rotarsi Al Sat Botu'nu telefon veya bilgisayara uygulama olarak yükleyin; işlem açılış/kapanış ve bot uyarılarını Telegram'a ek olarak cihaz bildirimi şeklinde alın. Bildirimler yalnızca bu tarayıcı/cihaz için geçerlidir — her cihazda ayrı açılır.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        <div data-testid="pwa-install-box" className="bg-[#0B0E17] border border-[#2A364F] rounded-md px-4 py-3 space-y-2">
          <div className="flex items-center gap-2 text-xs font-semibold text-[#94A3B8]"><Smartphone className="h-3.5 w-3.5" /><Monitor className="h-3.5 w-3.5" /> Uygulama olarak yükle</div>
          {standalone ? (
            <p className="text-xs text-[#10B981] font-semibold">Uygulama modunda çalışıyor ✓</p>
          ) : (
            <div className="flex flex-wrap gap-2">
              {canInstall && <button data-testid="pwa-install-settings-button" onClick={install} className="flex items-center gap-1.5 text-xs bg-[#3B82F6] hover:bg-[#2563EB] text-white rounded-md px-3 py-1.5"><Download className="h-3.5 w-3.5" /> Şimdi Yükle</button>}
              <button data-testid="pwa-guide-button" onClick={() => setGuide(true)} className="text-xs border border-[#2A364F] hover:border-[#3B82F6] rounded-md px-3 py-1.5">Nasıl yüklenir? (Android / iPhone / PC)</button>
            </div>
          )}
          {guide && <InstallGuide onClose={() => setGuide(false)} />}
        </div>

        <div data-testid="push-status-box" className={`rounded-md px-4 py-3 border space-y-2 ${sub ? "border-[#10B981]/40 bg-[#10B981]/10" : "border-[#2A364F] bg-[#0B0E17]"}`}>
          <div className="flex items-center gap-2 text-xs font-semibold">
            {sub ? <BellRing className="h-3.5 w-3.5 text-[#10B981]" /> : <BellOff className="h-3.5 w-3.5 text-[#64748B]" />}
            <span data-testid="push-status-text" className={sub ? "text-[#10B981]" : "text-[#94A3B8]"}>{sub ? "Bu cihazda AÇIK" : "Bu cihazda kapalı"}</span>
            {count !== null && <span className="text-[#64748B] font-normal">· toplam {count} cihaz</span>}
          </div>
          {!supported ? (
            <p className="text-[11px] text-[#F59E0B]">Bu tarayıcı anlık bildirimi desteklemiyor. iPhone'da önce Ana Ekrana ekleyip uygulamadan açın.</p>
          ) : denied ? (
            <p className="text-[11px] text-[#EF4444]">Bildirim izni engellenmiş — tarayıcı site ayarlarından izin verin.</p>
          ) : (
            <div className="flex gap-2">
              <button data-testid="push-toggle-button" onClick={toggle} disabled={busy} className={`text-xs rounded-md px-3 py-1.5 font-semibold disabled:opacity-50 ${sub ? "border border-[#EF4444]/50 text-[#EF4444] hover:bg-[#EF4444]/10" : "bg-[#3B82F6] hover:bg-[#2563EB] text-white"}`}>
                {sub ? "Bildirimleri Kapat" : "Bildirimleri Aç"}
              </button>
              {sub && <button data-testid="push-test-button" onClick={test} disabled={busy} className="text-xs border border-[#2A364F] hover:border-[#3B82F6] rounded-md px-3 py-1.5 disabled:opacity-50">Test Gönder</button>}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
